import { StatusCode } from "grpc-web";
import OrderService from "../services/OrderService";
import Notification from "../modules/notifications";
import { UPDATE_ACCOUNTS, UPDATE_USERS } from "../constants/actions";

export function ListAccounts() {
  return (dispatch) => {
    OrderService.listUsers((err, response) => {
      if (response) {
        let usersList = response.getUsersList();
        let usersDisplayNames = response.getDisplayNamesList();
        let firmsList = response.getFirmsList();
        let firmsDisplayNames = response.getFirmsDisplayNamesList();

        // If we fetched more users than the limit, display a warning but continue
        const MAX_USERS = 100;
        const MAX_ACCOUNTS = 100;
        if (usersList.length > MAX_USERS) {
          Notification.warning(
              `Max users reached: ${MAX_USERS}. "Order On Behalf Of" functionality will be limited.`
          );

          // Limit the number of users by truncating arrays in place to prevent performance issues
          usersList = usersList.slice(0, MAX_USERS);
          usersDisplayNames = usersDisplayNames.slice(0, MAX_USERS);
          firmsList = firmsList.slice(0, MAX_USERS);
          firmsDisplayNames = firmsDisplayNames.slice(0, MAX_USERS);
        }

        let users = new Map();
        let firms = new Map();
        let firmsToUsers = new Map();

        usersList.forEach((user, idx) =>
        {
          users.set(user, usersDisplayNames[idx]);

          const frm = firmsList[idx];
          firms.set(frm, firmsDisplayNames[idx]);

          let usersInFirm = firmsToUsers.has(frm) ? firmsToUsers.get(frm) : new Map();
          usersInFirm.set(user, true);
          firmsToUsers.set(frm, usersInFirm)

          OrderService.listAccounts(user,(err, response) => {
            if (response) {
              let accounts = new Map();

              let accountsList = response.getAccountsList();

              if (accountsList.length > MAX_ACCOUNTS) {
                Notification.warning(
                    `Max accounts reached: ${MAX_ACCOUNTS}. "Order On Behalf Of" functionality will be limited.`
                );

                // Limit the number of accounts by truncating array in place to prevent performance issues
                accountsList = accountsList.slice(0, MAX_ACCOUNTS);
              }

              let accountsDisplayNames = response.getDisplayNamesList();
              if (
                  !accountsDisplayNames ||
                  accountsDisplayNames.length !== accountsList.length
              ) {
                accountsDisplayNames = accountsList;
              }
              accountsList.forEach((account, idx) =>
                  accounts.set(account, accountsDisplayNames[idx])
              );

              dispatch({
                type: UPDATE_ACCOUNTS,
                payload: accounts,
                user: user,
              });
            }

            if (err) {
              switch (err.code) {
                case StatusCode.NOT_FOUND:
                  Notification.warning(
                      "Could not find any accounts associated with this participant"
                  );
                  break;
                default:
                  Notification.error(
                      `Error when querying accounts: \n ${err.message}`
                  );
                  break;
              }
            }
          });
        });
        dispatch({
          type: UPDATE_USERS,
          payload: users,
          firms: firms,
          firmsToUsers: firmsToUsers,
        });
      }

      if (err) {
        switch (err.code) {
          case StatusCode.NOT_FOUND:
            Notification.warning(
                "Could not find any users associated with this participant"
            );
            break;
          default:
            Notification.error(
                `Error when querying users: \n ${err.message}`
            );
            break;
        }
      }
    })
  };
}
